// extracted by mini-css-extract-plugin
export default {"expandBubble":"DetailBubble_expandBubble__W4X-j","expand":"DetailBubble_expand__a1MLb"};